import { defineComponent as _defineComponent } from 'vue'
import LoginEmail from '@/components/layout/loginPopup/LoginAddress.vue';
import Checkbox from "primevue/checkbox";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginChoose',
  props: {
  showAddressOption: {
    type: Boolean,
    default: true,
    required: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const termsAccepted = ref<boolean>(false);
function isMobile() {
   if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
     return true;
   } else {
     return false;
   }
 }

const __returned__ = { props, termsAccepted, isMobile, LoginEmail, get Checkbox() { return Checkbox } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})